export default __webpack_public_path__ + "static/media/legal-ip.77f447ed.svg";